import _ from 'lodash';
import React from 'react';

import './SettingsModal.scss';
import axios from '../../lib/AxiosInstance';
import { slideTitleFormatter } from '../../lib/titleFormatter';
import Tab from '../SettingsTab/Tab';
import TabContent from '../SettingsTab/TabContent';
import reducerStore from '../../reducers/reducerStore';
import competitionSlide from '../Slide/CompetitionSlide';

class SettingsModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            panels: [
                {
                    header: 'Skapa widget',
                    renderClass: 'CreateWidget',
                    changeWidgetType: this.changeTab.bind(this),
                },
                {
                    header: 'Widgetinställningar',
                    renderClass: 'ReportPanel',
                    changeWidgetType: this.changeWidgetType.bind(this),
                    showFooter: true,
                },
                // {
                //     header: 'Tävling',
                //     renderClass: 'CompetitionPanel',
                // },
            ],
            reports: {
                sales: [
                    {name: 'Försäljning', id: 'sales', icon: 'fa-usd'},
                    {name: 'Affärsmöjligheter', id: 'opportunities', icon: 'up-icon-pipeline'},
                    {name: 'Aktiviteter', id: 'activities', icon: 'fa-list'},
                    {name: 'Möten', id: 'meetings', icon: 'fa-calendar'},
                    {name: 'Telefonsamtal', id: 'saleCall', icon: 'fa-phone'},
                    {name: 'Tävling', id: 'competition', icon: 'fa-flag-checkered'},
                ],
                marketing: [
                    {name: 'Webbsidebesök', id: 'visits', icon: 'fa-globe'},
                    {name: 'Formulär', id: 'forms', icon: 'fa-file-text-o'},
                    {name: 'Massutskick', id: 'campaigns', icon: 'fa-envelope'},
                    //{name: 'Leads', id: 'leads', icon: 'fa-user'},
                ],
                custom: this.props.customWidgets,
            },
            activePanel: 0,
            widget: null,
            isNewCompetitionSlide: false,

            initialSlideId: null,
        };

        this.changeTab = this.changeTab.bind(this);
        this.changeWidgetType = this.changeWidgetType.bind(this);
        this.setWidgetFieldValue = this.setWidgetFieldValue.bind(this);
        this.saveWidget = this.saveWidget.bind(this);
        this.moveWidget = this.moveWidget.bind(this);
        this.deleteWidget = this.deleteWidget.bind(this);
    }

    componentWillMount() {
        const { editingSlide, editingWidget } = this.props;

        // Getting the config object to modify it an id was provided.
        if (editingWidget) {
            const lastState = reducerStore.getState();

            // Will be undefined if not found for some reason.
            const slideConfig = _.find(lastState.slides, ['id', editingSlide]);

            if(editingWidget === 'competition'){
                slideConfig.widgetType = 'competition';
                slideConfig.dataType = 'saleCompetition';
                slideConfig.dataConfig = {
                    include: {
                        type: 'all',
                        role: []
                    },
                    period: 'currentMonth',
                    dividedBy: 'user'
                };
                return this.setState({ widget: slideConfig, activePanel: 1 });
            }

            const widgetConfig = _.cloneDeep(_.find(slideConfig.widgets, ['_id', editingWidget]));

            return this.setState({ widget: widgetConfig, activePanel: 1 });
        }

        const defaultWidgetConfig = {
            width: 4,
            height: 4,
            x: 4,
            y: 0,
            dataType: '',
            dataConfig: {
                period: 'currentWeek',
                include: {
                    type: 'all',
                },
                dividedBy: 'total',
            },
            displayType: '',
        };

        return this.setState({ widget: defaultWidgetConfig });
    }

    setWidgetFieldValue(field, value) {
        const widget = this.state.widget;

        if (widget.widgetType === 'competition') {
            reducerStore.dispatch({ type: 'SET_COMPETITION_DATA', property: field, value: value, slideId: widget.id });            
        } else {
            _.set(widget, field, value);
        }

        if (field === 'dataType') {
            _.set(widget, 'dataConfig.stage.stages', []);
            _.set(widget, 'dataConfig.appointment.types', []);
        }
        this.setState({
            widget,
        });
    }

    changeTab(widgetType) {
        this.setState({
            activePanel: this.state.activePanel + 1,
            widget: Object.assign({}, this.state.widget, {widgetType})
        });
    }

    changeWidgetType(widget) {
        if(widget.widgetType === 'competition'){
            reducerStore.dispatch({ type: 'SET_NEW_COMPETITION_SLIDE' });
            reducerStore.dispatch({ type: 'ADD WIDGET', widget: competitionSlide.generateCompetitionWidgets(), slideId: this.props.editingSlide });
        }
        
        this.setState({
            widget: Object.assign({}, this.state.widget, widget)
        });
    }

    saveWidget() {
        const { editingSlide, editingWidget, tvIndex } = this.props;

        const widgetEndpoint = this.state.widget.dataConfig.endpoint;

        // Is only set when we have used move widget.
        const initialSlideId = this.state.initialSlideId;

        if (editingWidget && initialSlideId) {
            reducerStore.dispatch({ type: 'WIDGET MOVED', slideId: editingSlide, widget: this.state.widget });

            // Need to get the state because it has changed above.
            const newState = reducerStore.getState();

            // The widget has already been moved in the reducer state at this point.
            const slideToUpdate = _.find(newState.slides, ['id', editingSlide]);

            return axios.delete(`/api/salestv/${initialSlideId}/${editingWidget}`)
            .then(() => axios.put(`/api/salestv/${editingSlide}`, slideToUpdate))
            .then(() => {
                this.setState({ initialSlideId: null });

                this.props.stopEditing();
            }).catch(error => console.log(error));
        }

        if (editingWidget) {
            if (widgetEndpoint && widgetEndpoint.length > 1) {
                return axios.get(`/api/customWidgets/${widgetEndpoint}`)
                    .then((response) => {
                        const data = _.cloneDeep(this.state.widget);
                        data.displayConfig = response.data.displayConfig;
                        data.displayType = response.data.displayType;

                        return axios.put(`/api/salestv/${editingSlide}/${editingWidget}`, data)
                            .then((res) => {
                                const updatedWidget = res.data;

                                reducerStore.dispatch({
                                    type: 'WIDGET SAVED',
                                    slideId: editingSlide,
                                    widgetId: editingWidget,
                                    widget: updatedWidget,
                                });

                                this.props.stopEditing();
                            }).catch(error => console.log(error));
                    })
                    .catch(err => console.log(err));
            }
            
            if (this.state.widget.widgetType === 'competition') {
                let currentState = reducerStore.getState();
                let updatedSlide = _.find(currentState.slides, { 'type': 'competition', 'id': editingSlide });

                return axios.put(`/api/salestv/${editingSlide}`, updatedSlide).then(() => {
                    reducerStore.dispatch({ type: 'SLIDE SAVED', slide: updatedSlide });

                    //stop editing the slide
                    const states = { isEditingWidget: false };
                    reducerStore.dispatch({ type: 'STOP EDIT', states: states });
                }).catch(err => console.log(err));

            } else {

                return axios.put(`/api/salestv/${editingSlide}/${editingWidget}`, this.state.widget).then((res) => {
                    const updatedWidget = res.data;

                    reducerStore.dispatch({
                        type: 'WIDGET SAVED',
                        slideId: editingSlide,
                        widgetId: editingWidget,
                        widget: updatedWidget,
                    });

                    this.props.stopEditing();
                }).catch(error => console.log(error));
            }      
        }

        if (widgetEndpoint && widgetEndpoint.length > 1) {
            return axios.get(`/api/customWidgets/${this.state.widget.dataConfig.endpoint}`)
                .then((response) => {
                    this.state.widget.displayConfig = response.data.displayConfig;
                    this.state.widget.displayType = response.data.displayType;

                    return axios.post(`/api/salestv/${editingSlide}`, this.state.widget).then((res) => {
                        const createdWidget = res.data;

                        reducerStore.dispatch({
                            type: 'WIDGET CREATED',
                            slideId: editingSlide,
                            widgetId: createdWidget._id,
                            widget: createdWidget,
                        });

                        this.props.stopEditing();
                    }).catch(error => console.log(error));
                })
                .catch(err => console.log(err));
        }

        //if competition widget then save it as a slide else save the widget normally
        if (this.state.widget.widgetType === 'competition') {

            let currentState = reducerStore.getState();
            let slideToSave;
            _.some(currentState.slides, slide => {
                if (slide.type === 'competition' && !slide.id && this.state.isNewCompetitionSlide) {
                    slideToSave = slide;
                    return true;
                }
            });

            slideToSave.tvIndex = tvIndex;
            return axios.post(`/api/salestv`, slideToSave).then((newSlide) => {
                reducerStore.dispatch({ type: 'ADD SLIDE', data: newSlide.data });

                //remove the extra slide in the state as actual slide is saved to mongodb now
                reducerStore.dispatch({ type: 'REMOVE SLIDE', property: 'competition' });

                //stop editing the slide
                const states = { isEditingWidget: false };
                reducerStore.dispatch({ type: 'STOP EDIT', states: states });
            })
            .catch(err => console.log(err));

        } else {

            return axios.post(`/api/salestv/${editingSlide}`, this.state.widget)
                .then((res) => {
                    const createdWidget = res.data;

                    reducerStore.dispatch({
                        type: 'WIDGET CREATED',
                        slideId: editingSlide,
                        widgetId: createdWidget._id,
                        widget: createdWidget,
                    });

                    this.props.stopEditing();
                }).catch(error => console.log(error));
        }    
    }

    moveWidget(event) {
        const { editingSlide } = this.props;

        const selectedSlideId = event.target.value;

        if (this.state.initialSlideId == null && selectedSlideId !== editingSlide) {
            this.setState({ initialSlideId: editingSlide });
        }

        reducerStore.dispatch({ type: 'GO TO SLIDE', id: selectedSlideId });
    }

    deleteWidget() {
        const { editingSlide, editingWidget } = this.props;

        if (editingWidget === 'competition') { //deletes the competition slide
            axios.delete(`/api/salestv/${editingSlide}`).then(() => {
                reducerStore.dispatch({ type: 'REMOVE SLIDE', id: editingSlide });

                //stop editing the slide
                const states = { isEditingWidget: false };
                reducerStore.dispatch({ type: 'STOP EDIT', states: states });
                reducerStore.dispatch({ type: 'PREVIOUS SLIDE' }); //move to previous slide
            }).catch(error => console.log(error));
        } else {
            axios.delete(`/api/salestv/${editingSlide}/${editingWidget}`).then(() => {
                reducerStore.dispatch({
                    type: 'WIDGET REMOVED',
                    slideId: editingSlide,
                    widgetId: editingWidget,
                });

                this.props.stopEditing();
            }).catch(error => console.log(error));
        }
    }

    render() {
        const { panels, widget, activePanel, reports } = this.state;
        const { slides, stopEditing, editingSlide, editingWidget } = this.props;

        const tab = (
            <Tab
                header={panels[activePanel].header}
            />);

        this.state.isNewCompetitionSlide = editingWidget != 'competition' ? true : false;

        const tabContent = (
            <TabContent
                renderClass={panels[activePanel].renderClass}
                widget={widget}
                setWidgetFieldValue={this.setWidgetFieldValue}
                onChange={panels[activePanel].changeWidgetType}
                reports={reports}
                editingSlide={editingSlide}
                isNew={this.state.isNewCompetitionSlide}
            />
        );

        // Only show up when more thatn one slide and it's a new widget.
        const moveSlidesDisabled = slides.length < 2 || editingWidget == null;

        const moveSlidesOptions = slides.map((slide, index) => {
            if (slide.id === editingSlide) return null;

            return <option key={index} value={slide.id}>{slideTitleFormatter(slide.title)}</option>;
        });

        return (
            <div className="container">
                <div className="overlay" onClick={stopEditing} />
                <div className="modal edit-widget">
                    <div className="modal-header">
                        <ul>
                            {tab}
                        </ul>
                        <div className="exitButton pullRight" onClick={stopEditing}>
                            <i className="fa fa-times" />
                        </div>
                    </div>
                    <div className="modal-content">
                        {tabContent}
                    </div>
                    {panels[activePanel].showFooter &&
                        <div className="modal-footer">
                            <div style={{ display: 'inline-block' }}>
                                <button className="regular trash" onClick={this.deleteWidget}>
                                    <i className="fa fa-trash fa-lg" />
                                    Ta bort widget
                                </button>
                            </div>
                            <div style={{ float: 'right', display: 'inline-block' }}>
                                <button
                                    className="regular"
                                    onClick={stopEditing}
                                >
                                    Avbryt
                                </button>
                                <button
                                    className="blue"
                                    style={{ width: '150px' }}
                                    onClick={this.saveWidget}
                                >
                                    Spara
                                </button>
                            </div>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

SettingsModal.propTypes = {
    slides: React.PropTypes.array.isRequired,
    stopEditing: React.PropTypes.func.isRequired,
    editingSlide: React.PropTypes.string.isRequired,
    editingWidget: React.PropTypes.string,
    tvIndex: React.PropTypes.number,
};

export default SettingsModal;



/** WEBPACK FOOTER **
 ** ./client/components/SettingsModal/SettingsModal.jsx
 **/